"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHEET_COORDINATES_ORAMA_OPERACOES_CAMBIO = exports.SHEET_COORDINATES_ORAMA_OPERACOES_ESTRUTURADAS = exports.SHEET_COORDINATES_ORAMA_FUNDOS = exports.DEFAULT_VALUES_ORAMA_PERFORMANCE = exports.SHEET_COORDINATES_ORAMA_PERFORMANCE = exports.DEFAULT_VALUES_ORAMA_RENDA_FIXA = exports.SHEET_COORDINATES_ORAMA_RENDA_FIXA = exports.DEFAULT_VALUES_ORAMA_ERROS_OPERACIONAIS = exports.SHEET_COORDINATES_ORAMA_ERROS_OPERACIONAIS = exports.SHEET_COORDINATES_OURINVEST = exports.SHEET_COORDINATES_ICATU_PJ = exports.SHEET_COORDINATES_ICATU = exports.SHEET_COORDINATES_PREVIEW_BTG = exports.SHEET_COORDINATES_ICATU_BTG = exports.SHEET_COORDINATES_BTG_EXCHANGE = exports.SHEET_COORDINATES_BTG_PREV = exports.SHEET_COORDINATES_BTG_CORBAN = exports.SHEET_COORDINATES_BTG_COMMISSIONS = exports.SHEET_COORDINATES_ARGO = exports.SHEET_COORDINATES_GUIDE_COMMISSIONS = exports.SHEET_COORDINATES_MAPFRE_INSURANCE = exports.SHEET_COORDINATES_SULAMERICA = exports.SHEET_COORDINATES_PRUDENTIAL = exports.DEFAULT_VALUES_TREVISO_EXCHANGE = exports.DEFAULT_VALUES_CASHME_CORPORATE = exports.DEFAULT_VALUES_MANAGED_ASSETS = exports.DEFAULT_VALUES_MONGERAL_VG = exports.SHEET_COORDINATES_MONGERAL_VG = exports.SHEET_COORDINATES_MONGERAL = exports.SHEET_COORDINATES_GLOBUS = exports.SHEET_COORDINATES_SPLITC = exports.SHEET_COORDINATES_BTG_OFFSHORE = exports.SHEET_COORDINATES_XP_INTERNATIONAL_MARKET = exports.SHEET_COORDINATES_NEW_XP_OFFSHORE = exports.SHEET_COORDINATES_XP_OFFSHORE = exports.SHEET_COORDINATES_XPEED = exports.SHEET_COORDINATES_NEW_XP_EXCHANGE = exports.SHEET_COORDINATES_XP_EXCHANGE = exports.SHEET_COORDINATES_XPVP_XP = exports.SHEET_COORDINATES_NEW_XTAGE_XP = exports.SHEET_COORDINATES_NEW_XP_BANK = exports.SHEET_COORDINATES_XP_BANK = exports.SHEET_COORDINATES_XP_CO_BROKERAGE = exports.SHEET_COORDINATES_XP_PENSION = exports.SHEET_COORDINATES_NEW_XP_PENSION = exports.SHEET_COORDINATES_GENIAL_COMMISSIONS = exports.SHEET_COORDINATES_XP_MORTGAGE = exports.SHEET_COORDINATES_XP_COMMISSIONS_HUB = exports.SHEET_COORDINATES_XP_COMMISSIONS = exports.DEFAULT_OFFICE_CREDITOR = void 0;
exports.DisplayToOrigins = exports.OriginsToDisplay = exports.prettyOriginName = exports.getOrigins = exports.notShownOrigins = exports.OriginGroups = exports.DataTypeEnum = exports.DEFAULT_VALUES_CAMBIO_MASTER = exports.SHEET_COORDINATES_CAMBIO_MASTER = exports.DEFAULT_VALUES_CREDICLASS = exports.SHEET_COORDINATES_CREDICLASS = exports.DEFAULT_VALUES_REDE_DOR = exports.SHEET_COORDINATES_REDE_DOR = exports.SHEET_COORDINATES_SAFRA_ATIVOS = exports.SHEET_COORDINATES_SAFRA_INVEST = exports.SHEET_COORDINATES_TICKET_PAT = exports.DEFAULT_VALUES_PRUDENTIAL_BTG = exports.SHEET_COORDINATES_PRUDENTIAL_BTG = exports.SHEET_COORDINATES_OMINT = exports.SHEET_COORDINATES_BNK_EXCHANGE = exports.SHEET_COORDINATES_MANAGED_ASSETS = exports.SHEET_COORDINATES_CASHBACK_BTG = exports.SHEET_COORDINATES_CASHME_CORPORATE = exports.SHEET_COORDINATES_TREVISO_EXCHANGE = exports.SHEET_COORDINATES_BNK_PROTECT = exports.SHEET_COORDINATES_PORTO = exports.SHEET_COORDINATES_ZURICH = exports.SHEET_COORDINATES_UNIMED = exports.SHEET_COORDINATES_AVENUE = exports.SHEET_COORDINATES_INVESTORS_TRUST = exports.SHEET_COORDINATES_WARREN_COMMISSIONS = exports.DEFAULT_VALUES_ORAMA_OFERTA_PUBLICA = exports.SHEET_COORDINATES_MODAL_MONTHLY_COMMISSIONS = exports.SHEET_COORDINATES_MODAL_COMMISSIONS = exports.SHEET_COORDINATES_TERRA_COMMISSIONS = exports.SHEET_COORDINATES_AZIMUT = exports.SHEET_COORDINATES_ORAMA_OFERTA_PUBLICA = exports.DEFAULT_VALUES_ORAMA_RENDA_VARIAVEL = exports.SHEET_COORDINATES_ORAMA_RENDA_VARIAVEL = exports.DEFAULT_VALUES_ORAMA_FUNDOS = exports.SHEET_COORDINATES_ORAMA_OPERACOES_COE = void 0;
const user_1 = require("../user");
const origins_1 = require("./origins");
__exportStar(require("./origins"), exports);
exports.DEFAULT_OFFICE_CREDITOR = {
    creditor: 'ESCRITORIO',
};
exports.SHEET_COORDINATES_XP_COMMISSIONS = {
    category: 'B',
    client: 'F',
    commission: ['L'],
    creditor: 'N',
    header_row_number: 3,
    product: 'C',
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['I'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['J'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['K'],
        },
        {
            name: 'Data XP',
            columns: ['H'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_COMMISSIONS_HUB = {
    category: 'B',
    client: 'F',
    commission: ['K'],
    creditor: 'L',
    header_row_number: 1,
    product: 'C',
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['H'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['I'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['J'],
        },
        {
            name: 'Data XP',
            columns: ['G'],
        },
        {
            name: 'Classificacao',
            columns: ['A'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_MORTGAGE = {
    category: 'B',
    client: 'G',
    commission: ['M'],
    creditor: 'H',
    header_row_number: 1,
    product: 'C',
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_GENIAL_COMMISSIONS = {
    category: 'C',
    client: 'E',
    commission: ['N'],
    creditor: 'B',
    header_row_number: 1,
    product: 'D',
};
exports.SHEET_COORDINATES_NEW_XP_PENSION = {
    category: 'B',
    client: 'G',
    commission: ['M'],
    creditor: 'H',
    header_row_number: 1,
    product: 'C',
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_PENSION = {
    category: 'A',
    client: 'G',
    commission: ['AB'],
    creditor: 'D',
    header_row_number: 5,
    product: 'J',
    worksheet: 'Receitas',
};
exports.SHEET_COORDINATES_XP_CO_BROKERAGE = {
    category: 'A',
    client: 'G',
    commission: ['Z'],
    creditor: 'D',
    header_row_number: 5,
    product: 'J',
    worksheet: 'Co-Corretagem',
};
exports.SHEET_COORDINATES_XP_BANK = {
    category: 'G',
    client: 'F',
    commission: ['P'],
    creditor: 'D',
    header_row_number: 2,
    product: 'G',
    worksheet: 'Base',
};
exports.SHEET_COORDINATES_NEW_XP_BANK = {
    category: 'B',
    creditor: 'H',
    product: 'B',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_NEW_XTAGE_XP = {
    category: 'B',
    creditor: 'F',
    product: 'D',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XPVP_XP = {
    category: 'B',
    creditor: 'H',
    product: 'C',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_EXCHANGE = {
    category: '',
    creditor: 'J',
    client: 'A',
    commission: ['F'],
    header_row_number: 1,
    product: 'D',
    worksheet: 1,
};
exports.SHEET_COORDINATES_NEW_XP_EXCHANGE = {
    category: 'B',
    creditor: 'H',
    product: 'D',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XPEED = {
    category: 'B',
    creditor: 'E',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    product: 'D',
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_OFFSHORE = {
    category: 'I',
    creditor: '',
    client: 'C',
    commission: ['J'],
    header_row_number: 1,
    product: 'G',
    worksheet: 1,
};
exports.SHEET_COORDINATES_NEW_XP_OFFSHORE = {
    category: 'B',
    creditor: 'H',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    product: 'C',
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Nivel 2',
            columns: ['D'],
        },
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_XP_INTERNATIONAL_MARKET = {
    category: 'B',
    creditor: 'H',
    client: 'G',
    commission: ['M'],
    header_row_number: 1,
    product: 'E',
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Nivel 2',
            columns: ['D'],
        },
        {
            name: 'Receita Bruta XP',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida XP',
            columns: ['K'],
        },
        {
            name: 'Porcentagem Escritorio XP',
            columns: ['L'],
        },
        {
            name: 'Data XP',
            columns: ['I'],
        },
    ],
};
exports.SHEET_COORDINATES_BTG_OFFSHORE = {
    category: 'D',
    client: 'B',
    commission: ['J'],
    creditor: '',
    header_row_number: 5,
    product: 'E',
    worksheet: 1,
    arbitrary_fields: [{ name: 'nome_cliente', columns: ['B'] }],
};
exports.SHEET_COORDINATES_SPLITC = {
    category: 'C',
    creditor: 'B',
    client: 'A',
    commission: ['E'],
    product: 'D',
    header_row_number: 1,
    worksheet: 'SPLITC',
};
exports.SHEET_COORDINATES_GLOBUS = {
    category: 'D',
    client: 'A',
    commission: ['O'],
    creditor: 'J',
    header_row_number: 1,
    product: 'E',
};
exports.SHEET_COORDINATES_MONGERAL = {
    category: 'F',
    client: 'C',
    commission: ['J', 'L'],
    creditor: '',
    header_row_number: 4,
    product: 'F',
    arbitrary_fields: [
        { name: 'Parcela', columns: ['I'] },
        { name: 'Estorno', columns: ['L'] },
    ],
};
exports.SHEET_COORDINATES_MONGERAL_VG = {
    category: '',
    client: 'E',
    commission: ['I'],
    creditor: '',
    product: 'F',
    header_row_number: 4,
    worksheet: 1,
};
exports.DEFAULT_VALUES_MONGERAL_VG = {
    category: 'Mongeral VG',
};
exports.DEFAULT_VALUES_MANAGED_ASSETS = {
    category: 'Carteira Administrada',
    product: 'Carteira Administrada',
};
exports.DEFAULT_VALUES_CASHME_CORPORATE = {
    category: 'Cashme Corporate',
    product: 'Cashme Corporate',
};
exports.DEFAULT_VALUES_TREVISO_EXCHANGE = {
    category: 'Câmbio Treviso',
    product: 'Câmbio Treviso',
};
exports.SHEET_COORDINATES_PRUDENTIAL = {
    category: 'K',
    client: 'E',
    commission: ['I', 'J'],
    creditor: '',
    header_row_number: 1,
    product: 'K',
    worksheet: 1,
};
exports.SHEET_COORDINATES_SULAMERICA = {
    category: 'C',
    client: 'F',
    commission: ['K'],
    creditor: '',
    header_row_number: 1,
    product: 'D',
    worksheet: 1,
};
exports.SHEET_COORDINATES_MAPFRE_INSURANCE = {
    category: '',
    client: 'A',
    commission: ['E'],
    creditor: '',
    header_row_number: 1,
    product: '',
    worksheet: 1,
};
exports.SHEET_COORDINATES_GUIDE_COMMISSIONS = {
    category: 'I',
    client: 'A',
    commission: ['L'],
    creditor: 'C',
    header_row_number: 1,
    product: 'I',
    worksheet: 1,
};
exports.SHEET_COORDINATES_ARGO = {
    category: '',
    client: 'G',
    commission: ['Q'],
    creditor: '',
    header_row_number: 1,
    product: '',
    worksheet: 1,
};
exports.SHEET_COORDINATES_BTG_COMMISSIONS = {
    category: 'F',
    client: 'B',
    commission: ['M'],
    creditor: 'E',
    header_row_number: 5,
    product: 'H',
    worksheet: 'Detalhe',
    arbitrary_fields: [
        {
            name: 'Conta',
            columns: ['B'],
        },
        {
            name: 'Receita Bruta',
            columns: ['K'],
        },
        {
            name: 'Receita Liquida',
            columns: ['L'],
        },
        {
            name: 'Data Receita',
            columns: ['A'],
        },
        {
            name: 'nome_cliente',
            columns: ['C'],
        },
    ],
};
exports.SHEET_COORDINATES_BTG_CORBAN = {
    category: 'F',
    client: 'B',
    commission: ['M'],
    creditor: 'E',
    header_row_number: 5,
    product: 'H',
    worksheet: 'Detalhe',
    arbitrary_fields: [
        {
            name: 'Conta',
            columns: ['B'],
        },
        {
            name: 'Receita Bruta',
            columns: ['K'],
        },
        {
            name: 'Receita Liquida',
            columns: ['L'],
        },
        {
            name: 'Data Receita',
            columns: ['A'],
        },
        {
            name: 'nome_cliente',
            columns: ['C'],
        },
    ],
};
exports.SHEET_COORDINATES_BTG_PREV = {
    category: '',
    creditor: 'N',
    product: 'C',
    client: 'F',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 'Repasse',
    arbitrary_fields: [
        {
            name: 'Conta',
            columns: ['F'],
        },
        {
            name: 'Comissao Bruta',
            columns: ['L'],
        },
        {
            name: 'Percentual de Comissao',
            columns: ['K'],
        },
        {
            name: 'nome_cliente',
            columns: ['H'],
        },
    ],
};
exports.SHEET_COORDINATES_BTG_EXCHANGE = {
    category: 'E',
    creditor: 'D',
    product: 'F',
    client: 'B',
    commission: ['L'],
    header_row_number: 5,
    worksheet: 'Detalhe',
    arbitrary_fields: [
        {
            name: 'Receita Bruta',
            columns: ['J'],
        },
        {
            name: 'Receita Liquida',
            columns: ['K'],
        },
        {
            name: 'nome_cliente',
            columns: ['C'],
        },
    ],
};
exports.SHEET_COORDINATES_ICATU_BTG = {
    category: '',
    creditor: 'N',
    product: 'C',
    client: 'F',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 'Repasse',
    arbitrary_fields: [
        {
            name: 'Conta',
            columns: ['F'],
        },
        { name: 'Percentual de Comissão', columns: ['K'] },
        { name: 'Comissão Bruta', columns: ['L'] },
        { name: 'nome_cliente', columns: ['H'] },
    ],
};
exports.SHEET_COORDINATES_PREVIEW_BTG = {
    category: 'D',
    creditor: 'C',
    product: 'E',
    client: 'A',
    commission: ['M'],
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [{ name: 'nome_cliente', columns: ['B'] }],
};
exports.SHEET_COORDINATES_ICATU = {
    category: 'C',
    creditor: '',
    product: 'D',
    client: 'A',
    commission: ['O'],
    header_row_number: 5,
    worksheet: 'ExportexcelAnaliticoIndividuais',
};
exports.SHEET_COORDINATES_ICATU_PJ = {
    creditor: '',
    product: 'C',
    client: 'A',
    commission: ['G'],
    header_row_number: 11,
    worksheet: 1,
};
exports.SHEET_COORDINATES_OURINVEST = {
    category: '',
    creditor: '',
    product: 'F',
    client: 'D',
    commission: ['P'],
    header_row_number: 1,
    worksheet: 0,
    arbitrary_fields: [
        {
            name: 'Receita Bruta',
            columns: ['O'],
        },
        {
            name: 'Receita Liquida',
            columns: ['O'],
        },
        {
            name: 'Porcentagem Repasse',
            columns: ['P'],
        },
    ],
};
exports.SHEET_COORDINATES_ORAMA_ERROS_OPERACIONAIS = {
    worksheet: 'Resumo',
    header_row_number: 11,
    creditor: 'A',
    commission: ['F'],
};
exports.DEFAULT_VALUES_ORAMA_ERROS_OPERACIONAIS = {
    category: 'Erros Operacionais',
    product: 'Erros Operacionais',
};
exports.SHEET_COORDINATES_ORAMA_RENDA_FIXA = {
    worksheet: 'Memória RF',
    header_row_number: 1,
    creditor: 'T',
    commission: ['Y'],
    product: 'H',
    client: 'B',
};
exports.DEFAULT_VALUES_ORAMA_RENDA_FIXA = {
    category: 'RENDA FIXA',
};
exports.SHEET_COORDINATES_ORAMA_PERFORMANCE = {
    worksheet: 'Memória Performance',
    header_row_number: 1,
    creditor: 'D',
    commission: ['U'],
    product: 'F',
    client: 'B',
};
exports.DEFAULT_VALUES_ORAMA_PERFORMANCE = {
    category: 'PERFORMANCE',
};
exports.SHEET_COORDINATES_ORAMA_FUNDOS = {
    worksheet: 'Memória Fundos',
    header_row_number: 1,
    creditor: 'E',
    commission: ['S'],
    product: 'H',
    client: 'B',
};
exports.SHEET_COORDINATES_ORAMA_OPERACOES_ESTRUTURADAS = {
    worksheet: 'Memória Op. Estruturadas',
    header_row_number: 1,
    creditor: 'E',
    commission: ['N'],
    product: 'G',
    client: 'B',
};
exports.SHEET_COORDINATES_ORAMA_OPERACOES_CAMBIO = {
    worksheet: 'Memória Câmbio',
    header_row_number: 1,
    creditor: 'E',
    commission: ['K'],
    product: 'G',
    client: 'B',
};
exports.SHEET_COORDINATES_ORAMA_OPERACOES_COE = {
    worksheet: 'Memória COE',
    header_row_number: 1,
    creditor: 'E',
    commission: ['V'],
    product: 'G',
    client: 'B',
};
exports.DEFAULT_VALUES_ORAMA_FUNDOS = {
    category: 'FUNDOS',
};
exports.SHEET_COORDINATES_ORAMA_RENDA_VARIAVEL = {
    worksheet: 'Memória Renda Variável',
    header_row_number: 1,
    creditor: 'I',
    commission: ['K'],
    product: 'A',
    client: 'D',
};
exports.DEFAULT_VALUES_ORAMA_RENDA_VARIAVEL = {
    category: 'RENDA VARIAVEL',
};
exports.SHEET_COORDINATES_ORAMA_OFERTA_PUBLICA = {
    worksheet: 'Memória Oferta Pública',
    header_row_number: 1,
    creditor: 'E',
    commission: ['V'],
    product: 'I',
    client: 'B',
};
exports.SHEET_COORDINATES_AZIMUT = {
    worksheet: 'BASE',
    header_row_number: 1,
    creditor: 'F',
    category: 'J',
    commission: ['N'],
    product: 'K',
    client: 'C',
};
exports.SHEET_COORDINATES_TERRA_COMMISSIONS = {
    category: 'I',
    client: 'A',
    commission: ['H'],
    creditor: '',
    header_row_number: 8,
    product: 'I',
};
exports.SHEET_COORDINATES_MODAL_COMMISSIONS = {
    category: 'H',
    client: 'B',
    commission: ['G'],
    creditor: '',
    header_row_number: 31,
    product: 'H',
};
exports.SHEET_COORDINATES_MODAL_MONTHLY_COMMISSIONS = {
    category: 'B',
    client: 'E',
    commission: ['K'],
    creditor: 'L',
    header_row_number: 1,
    product: 'D',
    arbitrary_fields: [
        {
            name: 'Info Produto',
            columns: ['H'],
        },
    ],
};
exports.DEFAULT_VALUES_ORAMA_OFERTA_PUBLICA = {
    category: 'OFERTA PUBLICA',
};
exports.SHEET_COORDINATES_WARREN_COMMISSIONS = {
    category: '',
    creditor: '',
    client: 'B',
    commission: ['J'],
    product: 'E',
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_INVESTORS_TRUST = {
    category: 'B',
    creditor: 'C',
    client: 'D',
    commission: ['L'],
    product: 'F',
    header_row_number: 1,
    worksheet: 'InvestorsTrust',
};
exports.SHEET_COORDINATES_AVENUE = {
    category: 'G',
    creditor: 'F',
    client: 'C',
    commission: ['S'],
    product: 'H',
    header_row_number: 1,
    worksheet: 1,
    arbitrary_fields: [
        {
            name: 'Receita Bruta',
            columns: ['O'],
        },
        {
            name: 'Receita Liquida',
            columns: ['Q'],
        },
        {
            name: 'Porcentagem Repasse',
            columns: ['R'],
        },
    ],
};
exports.SHEET_COORDINATES_UNIMED = {
    category: 'E',
    creditor: '',
    product: 'N',
    client: 'H',
    commission: ['T'],
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_ZURICH = {
    category: '',
    creditor: '',
    client: 'F',
    commission: ['I'],
    product: 'B',
    header_row_number: 8,
    worksheet: 1,
};
exports.SHEET_COORDINATES_PORTO = {
    category: '',
    creditor: '',
    client: 'A',
    commission: ['L'],
    product: 'B',
    header_row_number: 8,
    worksheet: 1,
};
exports.SHEET_COORDINATES_BNK_PROTECT = {
    category: 'G',
    creditor: 'C',
    client: 'B',
    commission: ['K'],
    product: 'F',
    header_row_number: 1,
    worksheet: 2,
};
exports.SHEET_COORDINATES_TREVISO_EXCHANGE = {
    category: '',
    creditor: '',
    client: 'S',
    commission: ['G'],
    product: '',
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_CASHME_CORPORATE = {
    category: '',
    creditor: '',
    client: 'D',
    commission: ['G'],
    product: '',
    header_row_number: 4,
    worksheet: 0,
};
exports.SHEET_COORDINATES_CASHBACK_BTG = {
    category: 'E',
    creditor: '',
    client: 'B',
    commission: ['L'],
    product: 'F',
    header_row_number: 5,
    worksheet: 'Detalhe',
    arbitrary_fields: [{ name: 'nome_cliente', columns: ['C'] }],
};
exports.SHEET_COORDINATES_MANAGED_ASSETS = {
    category: '',
    creditor: '',
    client: 'B',
    commission: ['C'],
    product: '',
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_BNK_EXCHANGE = {
    category: 'M',
    creditor: 'I',
    client: 'D',
    commission: ['Z'],
    product: 'P',
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_OMINT = {
    category: '',
    creditor: '',
    client: 'D',
    commission: ['J'],
    product: 'G',
    header_row_number: 1,
    worksheet: 'Table 1',
};
exports.SHEET_COORDINATES_PRUDENTIAL_BTG = {
    category: '',
    client: 'D',
    commission: ['I', 'J'],
    creditor: '',
    header_row_number: 1,
    product: 'K',
    worksheet: 1,
    arbitrary_fields: [{ name: 'nome_cliente', columns: ['F'] }],
};
exports.DEFAULT_VALUES_PRUDENTIAL_BTG = {
    category: 'Prudential BTG',
};
exports.SHEET_COORDINATES_TICKET_PAT = {
    category: '',
    creditor: '',
    client: 'F',
    commission: ['X'],
    product: 'G',
    header_row_number: 1,
    worksheet: 1,
};
exports.SHEET_COORDINATES_SAFRA_INVEST = {
    category: 'H',
    creditor: 'E',
    client: 'D',
    commission: ['R'],
    product: 'J',
    header_row_number: 10,
    worksheet: 'Saida2_Analitico',
};
exports.SHEET_COORDINATES_SAFRA_ATIVOS = {
    category: 'F',
    creditor: 'E',
    client: 'D',
    commission: ['N'],
    product: 'F',
    header_row_number: 44,
    worksheet: 'Saida_Ativos',
};
exports.SHEET_COORDINATES_REDE_DOR = {
    category: '',
    creditor: 'B',
    client: 'D',
    commission: ['H'],
    product: 'E',
    header_row_number: 3,
    worksheet: 1,
};
exports.DEFAULT_VALUES_REDE_DOR = {
    category: 'Rede D’or',
};
exports.SHEET_COORDINATES_CREDICLASS = {
    category: '',
    creditor: 'M',
    client: 'D',
    commission: ['K'],
    product: 'A',
    header_row_number: 7,
    worksheet: 1,
};
exports.DEFAULT_VALUES_CREDICLASS = {
    category: 'Crediclass',
};
exports.SHEET_COORDINATES_CAMBIO_MASTER = {
    category: '',
    creditor: '',
    client: 'C',
    commission: ['N'],
    product: '',
    header_row_number: 1,
    worksheet: 1,
};
exports.DEFAULT_VALUES_CAMBIO_MASTER = {
    category: 'Câmbio Master',
    product: 'Câmbio Master',
};
var DataTypeEnum;
(function (DataTypeEnum) {
    DataTypeEnum[DataTypeEnum["Comissoes"] = 1] = "Comissoes";
    DataTypeEnum[DataTypeEnum["Net"] = 2] = "Net";
    DataTypeEnum[DataTypeEnum["Antigo"] = 3] = "Antigo";
    DataTypeEnum[DataTypeEnum["M\u00E9tricas"] = 4] = "M\u00E9tricas";
    DataTypeEnum[DataTypeEnum["Integra\u00E7\u00F5es"] = 5] = "Integra\u00E7\u00F5es";
})(DataTypeEnum = exports.DataTypeEnum || (exports.DataTypeEnum = {}));
var OriginGroups;
(function (OriginGroups) {
    OriginGroups["XP_INVESTIMENTOS"] = "Xp Investimentos";
    OriginGroups["BTG_PACTUAL"] = "BTG Pactual";
    OriginGroups["AZIMUT"] = "Azimut";
    OriginGroups["SEGURADORAS_PARCEIROS"] = "Seguradoras e Parceiros";
    OriginGroups["SPLITC"] = "SplitC";
    OriginGroups["OUTROS"] = "Outros";
})(OriginGroups = exports.OriginGroups || (exports.OriginGroups = {}));
const notShownOrigins = () => {
    return {
        comissao_minima: {
            display: 'Comissão Mínima',
            key: 'comissao_minima',
            addresses: [],
            group: OriginGroups.OUTROS,
            dataType: 1,
            claims: [],
        },
    };
};
exports.notShownOrigins = notShownOrigins;
const getOrigins = () => {
    return {
        [origins_1.ORIGINS.comissoes_xp_api]: {
            display: 'API XP',
            addresses: [],
            key: origins_1.ORIGINS.comissoes_xp_api,
            group: OriginGroups.XP_INVESTIMENTOS,
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
            dataType: DataTypeEnum.Integrações,
            apiName: origins_1.ORIGINS.comissoes_xp,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE, user_1.UsersClaims.XP_INTEGRATION_CONFIG],
        },
        [origins_1.ORIGINS.comissoes_xp_hub]: {
            display: 'Comissões XP (HUB)',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_COMMISSIONS_HUB }],
            key: origins_1.ORIGINS.comissoes_xp_hub,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.comissoes_xp]: {
            display: 'Comissões XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_COMMISSIONS }],
            key: origins_1.ORIGINS.comissoes_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.new_previdencia_xp]: {
            display: 'Previdência XP - NOVO',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XP_PENSION }],
            key: origins_1.ORIGINS.new_previdencia_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            hiddenOnRuleSelectors: true,
        },
        [origins_1.ORIGINS.new_co_corretagem_xp]: {
            display: 'Co-corretagem XP - NOVO',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XP_PENSION }],
            key: origins_1.ORIGINS.new_co_corretagem_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            hiddenOnRuleSelectors: true,
        },
        [origins_1.ORIGINS.studio_xp]: {
            display: 'Studio XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XP_BANK }],
            key: origins_1.ORIGINS.studio_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            hiddenOnRuleSelectors: true,
        },
        [origins_1.ORIGINS.new_banco_xp]: {
            display: 'Banco XP - NOVO',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XP_BANK }],
            key: origins_1.ORIGINS.new_banco_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            hiddenOnRuleSelectors: true,
        },
        [origins_1.ORIGINS.new_cambio_xp]: {
            display: 'Câmbio XP - NOVO',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_NEW_XP_EXCHANGE,
                },
            ],
            key: origins_1.ORIGINS.new_cambio_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            hiddenOnRuleSelectors: true,
        },
        [origins_1.ORIGINS.new_offshore_xp]: {
            display: 'Offshore XP - NOVO',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_NEW_XP_OFFSHORE,
                },
            ],
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
            key: origins_1.ORIGINS.new_offshore_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.investimento_global_xp]: {
            display: 'Mercado Internacional XP',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_XP_INTERNATIONAL_MARKET,
                },
            ],
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
            key: origins_1.ORIGINS.investimento_global_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.offshore_xp]: {
            display: 'Offshore XP',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_XP_OFFSHORE,
                    constant_values: {
                        creditor: 'ESCRITORIO',
                    },
                },
            ],
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
            key: origins_1.ORIGINS.offshore_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.xpeed_xp]: {
            display: 'Xpeed XP',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_XPEED,
                },
            ],
            key: origins_1.ORIGINS.xpeed_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.dm10]: {
            display: 'DM10',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XP_PENSION }],
            key: origins_1.ORIGINS.dm10,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.xtage_xp]: {
            display: 'XSTAGE',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_NEW_XTAGE_XP }],
            key: origins_1.ORIGINS.xtage_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.xpvp_xp]: {
            display: 'XPVP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XPVP_XP }],
            key: origins_1.ORIGINS.xpvp_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.financiamento_imobiliario_xp]: {
            display: 'Financiamento Imobiliário XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_MORTGAGE }],
            key: origins_1.ORIGINS.financiamento_imobiliario_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.previdencia_xp]: {
            display: 'Previdência XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_PENSION }],
            key: origins_1.ORIGINS.previdencia_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.co_corretagem_xp]: {
            display: 'Co-corretagem XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_CO_BROKERAGE }],
            key: origins_1.ORIGINS.co_corretagem_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.banco_xp]: {
            display: 'Banco XP',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_XP_BANK }],
            key: origins_1.ORIGINS.banco_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.cambio_xp]: {
            display: 'Câmbio XP',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_XP_EXCHANGE,
                    constant_values: {
                        category: 'Câmbio',
                    },
                },
            ],
            key: origins_1.ORIGINS.cambio_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Antigo,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.positivador_xp]: {
            display: 'Positivador',
            key: origins_1.ORIGINS.positivador_xp,
            group: OriginGroups.XP_INVESTIMENTOS,
            dataType: DataTypeEnum.Net,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.base_btg]: {
            display: 'Base BTG',
            key: origins_1.ORIGINS.base_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Net,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.comissoes_guide]: {
            display: 'Comissões Guide',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_GUIDE_COMMISSIONS }],
            key: origins_1.ORIGINS.comissoes_guide,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.globus]: {
            display: 'Globus',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_GLOBUS,
                },
            ],
            key: origins_1.ORIGINS.globus,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.mongeral]: {
            display: 'Mongeral',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_MONGERAL }],
            key: origins_1.ORIGINS.mongeral,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.mongeral_vg]: {
            display: 'Mongeral VG',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_MONGERAL_VG, constant_values: exports.DEFAULT_VALUES_MONGERAL_VG },
            ],
            key: origins_1.ORIGINS.mongeral_vg,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.prudential]: {
            display: 'Prudential',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_PRUDENTIAL }],
            key: origins_1.ORIGINS.prudential,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.icatu]: {
            display: 'Icatu',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_ICATU, constant_values: exports.DEFAULT_OFFICE_CREDITOR },
            ],
            key: origins_1.ORIGINS.icatu,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.icatu_pj]: {
            display: 'Icatu PJ',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_ICATU_PJ,
                    constant_values: {
                        creditor: 'ESCRITORIO',
                        category: 'Icatu PJ',
                    },
                },
            ],
            key: origins_1.ORIGINS.icatu_pj,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.sulamerica]: {
            display: 'Sulamérica Seguros',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_SULAMERICA, constant_values: exports.DEFAULT_OFFICE_CREDITOR },
            ],
            key: origins_1.ORIGINS.sulamerica,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.mapfre]: {
            display: 'Mapfre',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_MAPFRE_INSURANCE,
                    constant_values: {
                        category: 'Mapfre',
                        creditor: 'Escritorio',
                        product: 'Mapfre Seguros',
                    },
                },
            ],
            key: origins_1.ORIGINS.mapfre,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.ourinvest]: {
            display: 'Ourinvest',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_OURINVEST,
                    constant_values: { creditor: 'ESCRITORIO', category: 'Ourinvest' },
                },
            ],
            key: origins_1.ORIGINS.ourinvest,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.warren]: {
            display: 'Comissões Warren',
            addresses: [
                {
                    constant_values: { category: 'Warren' },
                    coordinates: exports.SHEET_COORDINATES_WARREN_COMMISSIONS,
                },
            ],
            key: origins_1.ORIGINS.warren,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.unimed]: {
            display: 'Unimed',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_UNIMED, constant_values: exports.DEFAULT_OFFICE_CREDITOR },
            ],
            key: origins_1.ORIGINS.unimed,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.zurich]: {
            display: 'Zurich',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_ZURICH,
                    constant_values: {
                        category: 'Zurich',
                        creditor: exports.DEFAULT_OFFICE_CREDITOR.creditor,
                    },
                },
            ],
            key: origins_1.ORIGINS.zurich,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.porto_seguro]: {
            display: 'Porto Seguro',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_PORTO,
                    constant_values: {
                        category: 'Porto Seguro',
                        creditor: exports.DEFAULT_OFFICE_CREDITOR.creditor,
                    },
                },
            ],
            key: origins_1.ORIGINS.porto_seguro,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.comissoes_btg]: {
            display: 'Comissões BTG',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_BTG_COMMISSIONS }],
            key: origins_1.ORIGINS.comissoes_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.previdencia_btg]: {
            display: 'Previdência BTG',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_BTG_PREV,
                    constant_values: {
                        category: 'Previdência',
                    },
                },
            ],
            key: origins_1.ORIGINS.previdencia_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.cambio_btg]: {
            display: 'Câmbio BTG',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_BTG_EXCHANGE }],
            key: origins_1.ORIGINS.cambio_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.icatu_btg]: {
            display: 'Icatu BTG',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_ICATU_BTG,
                    constant_values: {
                        category: 'Icatu Previdência',
                    },
                },
            ],
            key: origins_1.ORIGINS.icatu_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.previa_btg]: {
            display: 'Prévia BTG',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_PREVIEW_BTG }],
            key: origins_1.ORIGINS.previa_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.comissoes_genial]: {
            display: 'Comissões Genial',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_GENIAL_COMMISSIONS,
                },
            ],
            key: origins_1.ORIGINS.comissoes_genial,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.azimut]: {
            display: 'Azimut',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_AZIMUT,
                },
            ],
            key: origins_1.ORIGINS.azimut,
            group: OriginGroups.AZIMUT,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.superbase_azimut]: {
            display: 'Superbase',
            key: origins_1.ORIGINS.superbase_azimut,
            group: OriginGroups.AZIMUT,
            dataType: DataTypeEnum.Net,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.orama]: {
            display: 'Comissões Órama',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_ERROS_OPERACIONAIS,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_ERROS_OPERACIONAIS,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_RENDA_FIXA,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_RENDA_FIXA,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_PERFORMANCE,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_PERFORMANCE,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_FUNDOS,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_FUNDOS,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_RENDA_VARIAVEL,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_RENDA_VARIAVEL,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_OFERTA_PUBLICA,
                    constant_values: exports.DEFAULT_VALUES_ORAMA_OFERTA_PUBLICA,
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_OPERACOES_ESTRUTURADAS,
                    constant_values: {
                        category: 'Operações Estruturadas',
                    },
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_OPERACOES_CAMBIO,
                    constant_values: {
                        category: 'Câmbio',
                    },
                },
                {
                    coordinates: exports.SHEET_COORDINATES_ORAMA_OPERACOES_COE,
                    constant_values: {
                        category: 'COE',
                    },
                },
            ],
            key: origins_1.ORIGINS.orama,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.terra]: {
            display: 'Comissões Terra',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_TERRA_COMMISSIONS }],
            key: origins_1.ORIGINS.terra,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.modal]: {
            display: 'Comissões Modal',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_MODAL_COMMISSIONS }],
            key: origins_1.ORIGINS.modal,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.modal_mensal]: {
            display: 'Comissões Modal Mensal',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_MODAL_MONTHLY_COMMISSIONS }],
            key: origins_1.ORIGINS.modal_mensal,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.investors_trust]: {
            display: 'Investors Trust',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_INVESTORS_TRUST,
                },
            ],
            additional_data: [
                {
                    key: 'currency.exchange.rate',
                    display: 'Cotação da Moeda (R$)',
                },
            ],
            key: origins_1.ORIGINS.investors_trust,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.avenue]: {
            display: 'Avenue',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_AVENUE,
                },
            ],
            key: origins_1.ORIGINS.avenue,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.avenue_estrangeira]: {
            display: 'Avenue - Moeda Estrangeira',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_AVENUE,
                },
            ],
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
            key: origins_1.ORIGINS.avenue_estrangeira,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.bnk_protect]: {
            display: 'Protect',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_BNK_PROTECT }],
            key: origins_1.ORIGINS.bnk_protect,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.bnk_exchange]: {
            display: 'Câmbio BNK',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_BNK_EXCHANGE }],
            key: origins_1.ORIGINS.bnk_exchange,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.omint]: {
            display: 'Omint',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_OMINT,
                    constant_values: { ...exports.DEFAULT_OFFICE_CREDITOR, category: 'Omint' },
                },
            ],
            key: origins_1.ORIGINS.omint,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.ticket_pat]: {
            display: 'Ticket Pat',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_TICKET_PAT,
                    constant_values: { ...exports.DEFAULT_OFFICE_CREDITOR, category: 'Ticket PAT' },
                },
            ],
            key: origins_1.ORIGINS.ticket_pat,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.prudential_btg]: {
            display: 'Prudential BTG',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_PRUDENTIAL_BTG,
                    constant_values: exports.DEFAULT_VALUES_PRUDENTIAL_BTG,
                },
            ],
            key: origins_1.ORIGINS.prudential_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.btg_corban]: {
            display: 'Corban BTG',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_BTG_CORBAN,
                },
            ],
            key: origins_1.ORIGINS.btg_corban,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.rede_dor]: {
            display: 'Rede D’or',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_REDE_DOR, constant_values: exports.DEFAULT_VALUES_REDE_DOR },
            ],
            key: origins_1.ORIGINS.rede_dor,
            group: OriginGroups.SEGURADORAS_PARCEIROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.crediclass]: {
            display: 'Crediclass',
            addresses: [
                { coordinates: exports.SHEET_COORDINATES_CREDICLASS, constant_values: exports.DEFAULT_VALUES_CREDICLASS },
            ],
            key: origins_1.ORIGINS.crediclass,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.cambio_master]: {
            display: 'Câmbio Master',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_CAMBIO_MASTER,
                    constant_values: exports.DEFAULT_VALUES_CAMBIO_MASTER,
                },
            ],
            key: origins_1.ORIGINS.cambio_master,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.splitc]: {
            display: 'SplitC',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_SPLITC }],
            key: origins_1.ORIGINS.splitc,
            group: OriginGroups.SPLITC,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.treviso_exchange]: {
            display: 'Câmbio Treviso',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_TREVISO_EXCHANGE,
                    constant_values: exports.DEFAULT_VALUES_TREVISO_EXCHANGE,
                },
            ],
            key: origins_1.ORIGINS.treviso_exchange,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.cashme_corporate]: {
            display: 'Cashme Corporate',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_CASHME_CORPORATE,
                    constant_values: exports.DEFAULT_VALUES_CASHME_CORPORATE,
                },
            ],
            key: origins_1.ORIGINS.cashme_corporate,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.managed_assets]: {
            display: 'Carteira Administrada',
            addresses: [
                {
                    coordinates: exports.SHEET_COORDINATES_MANAGED_ASSETS,
                    constant_values: exports.DEFAULT_VALUES_MANAGED_ASSETS,
                },
            ],
            key: origins_1.ORIGINS.managed_assets,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.cashback_assets_btg]: {
            display: 'Cashback Asset BTG',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_CASHBACK_BTG }],
            key: origins_1.ORIGINS.cashback_assets_btg,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.btg_offshore]: {
            display: 'Offshore BTG',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_BTG_OFFSHORE }],
            key: origins_1.ORIGINS.btg_offshore,
            group: OriginGroups.BTG_PACTUAL,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
            additional_data: [
                {
                    key: 'exchange.rate.usd',
                    display: 'Cotação do Dólar',
                },
            ],
        },
        [origins_1.ORIGINS.splitc_metricas]: {
            display: 'SplitC Métricas',
            addresses: [],
            key: origins_1.ORIGINS.splitc_metricas,
            group: OriginGroups.SPLITC,
            dataType: DataTypeEnum.Métricas,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.splitc_aum]: {
            display: 'SplitC - AuM',
            key: origins_1.ORIGINS.splitc_aum,
            group: OriginGroups.SPLITC,
            dataType: DataTypeEnum.Net,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.argo]: {
            display: 'Argo',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_ARGO }],
            key: origins_1.ORIGINS.argo,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.safra_invest]: {
            display: 'Safra Invest',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_SAFRA_INVEST }],
            key: origins_1.ORIGINS.safra_invest,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
        [origins_1.ORIGINS.safra_ativos]: {
            display: 'Safra Ativos',
            addresses: [{ coordinates: exports.SHEET_COORDINATES_SAFRA_ATIVOS }],
            key: origins_1.ORIGINS.safra_ativos,
            group: OriginGroups.OUTROS,
            dataType: DataTypeEnum.Comissoes,
            claims: [user_1.UsersClaims.CLOSURE_UPDATE],
        },
    };
};
exports.getOrigins = getOrigins;
const prettyOriginName = (origin) => (0, exports.getOrigins)()[origin]?.display ?? (0, exports.notShownOrigins)()[origin]?.display ?? origin;
exports.prettyOriginName = prettyOriginName;
exports.OriginsToDisplay = Object.fromEntries(Object.entries((0, exports.getOrigins)()).map(([key, content]) => {
    return [key, content.display];
}));
exports.DisplayToOrigins = Object.fromEntries(Object.entries((0, exports.getOrigins)()).map(([key, content]) => {
    return [content.display, key];
}));
